import { createSelector } from '@reduxjs/toolkit';
import { selectFloor } from './select-floor';

export const selectTimeZone = createSelector([selectFloor], (floor) => {
  return floor?.time_zone || 'UTC';
});
